import { KybDocumentType } from '__generated__/GQL';

/**
 * Returns the type of KYB document we require for a company's proof of registration.
 */
const getCompanyPapersDocumentType = ({ isEi }: { isEi: boolean }) =>
  isEi
    ? KybDocumentType.CompanyRegistrationOfficialPaper
    : KybDocumentType.Kbis;

export default getCompanyPapersDocumentType;
